import http from './http';

const apiVersion = 'v1';
const uploadUrl = `/${apiVersion}/images/upload`;

const uploadFile = async (
	file: File | string,
	required = true,
	minWidth?: number,
	minHeight?: number,
	minShortestSide?: number,
	minLongestSide?: number,
	removeBackground = false,
	crop = false,
) => {
	const formData = new FormData();
	if (file instanceof File) {
		formData.append('image_file', file);
	} else {
		formData.append('image_url', file);
	}

	const params = new URLSearchParams();
	params.append('required', String(required));
	params.append('removeBackground', String(removeBackground));
	params.append('crop', String(crop));
	if (minWidth !== undefined) {
		params.append('minWidth', String(minWidth));
	}
	if (minHeight !== undefined) {
		params.append('minHeight', String(minHeight));
	}
	if (minShortestSide && minLongestSide) {
		params.append('minShortestSide', String(minShortestSide));
		params.append('minLongestSide', String(minLongestSide));
	}

	const { data } = await http.post(
		`${uploadUrl}?${params.toString()}`,
		formData,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		},
	);

	return data;
};

export { uploadFile };
